module.exports = __webpack_public_path__ + "img/DMSS-w.7e6b3092.svg";